import React, { createContext, useContext, useEffect, useState } from 'react';
import { publicApi } from '../api/client';

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    brand: 'Get Nile Cruise',
    phone: '+20 155 928 5650',
    phone_raw: '+201559285650',
    email: 'info@getnilecruise.com',
    address: '15 Al-Mostashfa El Ferancawy St., Aswan, Egypt',
    hero_title: 'The ultimate collection of Egypt River Cruise',
    hero_subtitle: "Experience timeless elegance on legendary Nile cruises and Egypt tours.",
    hero_images: [],
    tagline: "Egypt's most trusted Nile river cruise specialists",
    social_facebook: '', social_instagram: '', social_twitter: '', social_youtube: '',
  });
  const [loaded, setLoaded] = useState(false);

  const refresh = async () => {
    try {
      const s = await publicApi.getSettings();
      setSettings(s);
    } catch (e) {
      // ignore
    } finally {
      setLoaded(true);
    }
  };

  useEffect(() => { refresh(); }, []);

  return <SettingsContext.Provider value={{ settings, loaded, refresh }}>{children}</SettingsContext.Provider>;
};

export const useSettings = () => useContext(SettingsContext).settings;
export const useSettingsContext = () => useContext(SettingsContext);
